module.exports = __webpack_public_path__ + "img/no-assess-data.176248af.svg";